import { render, staticRenderFns } from "./WxAccountList.vue?vue&type=template&id=3ee6c820&scoped=true&"
import script from "./WxAccountList.vue?vue&type=script&lang=js&"
export * from "./WxAccountList.vue?vue&type=script&lang=js&"
import style0 from "./WxAccountList.vue?vue&type=style&index=0&id=3ee6c820&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ee6c820",
  null
  
)

export default component.exports